import { StrictMode } from 'react'

import { createRoot } from 'react-dom/client'

import '@web/app/styles/index.css'
// импортируется как CSS-модуль (не через @import), чтобы :export не утёк
// в общий бандл CSS — см. entities/threshold/model/threshold.constant.ts
import '@web/app/styles/core/severity-colors.module.css'
import App from '@web/app/app'

const mcmApp = createRoot(document.getElementById('root') as HTMLElement)

mcmApp.render(
  <StrictMode>
    <App />
  </StrictMode>
)
